module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row offer-filter pad"
  }, [_c('div', {
    staticClass: "col-md-12 padTop"
  }, [_c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "info",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.Storage.OldbyWmFilter),
      callback: function($$v) {
        _vm.Storage.OldbyWmFilter = $$v
      },
      expression: "Storage.OldbyWmFilter"
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  })), _vm._v("\n    " + _vm._s(_vm.$t('filters.by_wm')) + "\n  ")], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dbf2052"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/filters/OldWmFilter.vue
// module id = 534
// module chunks = 0